export enum IssueSeverity {
  Good = 'good',
  Info = 'info',
  Warn = 'warn',
  Error = 'error'
}

export type AndroidLogLevel = 'VERBOSE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERR' | 'FATAL';
export const AndroidLogLevels: AndroidLogLevel[] = ['VERBOSE', 'DEBUG', 'INFO', 'WARN', 'ERR', 'FATAL']

export type IOSLogLevel = 'DEBUG' | 'INFO' | 'NOTICE' | 'ERR' | 'FAULT';
export const IOSLogLevels: IOSLogLevel[] = ['DEBUG', 'INFO', 'NOTICE', 'ERR', 'FAULT']

export type LogType = AndroidLogLevel | IOSLogLevel | 'LOG';
